import { render, staticRenderFns } from "./ProfileUserOld.vue?vue&type=template&id=52789935"
import script from "./ProfileUserOld.vue?vue&type=script&lang=js"
export * from "./ProfileUserOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports